import React from 'react';
import style from './App.less';

class Agreement extends React.PureComponent {
    state={
        showloading:true
    }
    componentDidMount(){
       
        setTimeout(()=>{
            this.setState({
                showloading:false
            })
        },400)
        document.title="TCL用户协议"
    }
    render(){
        return (
            <div>
              {this.state.showloading&&<div className={style.white}></div>}
              <div className={style.fonted}>
                    <div>
                        <p style={{"textIndent":"2em"}}>
                             感谢您使用TCL（以下简称“服务平台”）所提供的产品和服务！注册前请仔细阅读、充分理解以下协议内容，
                            <b>尤其是免责条款、管辖条款（免责条款、管辖条款已经以加粗的形式提醒你注意），您的注册、登录和使用等行为将视为对《TCL用户协议》（以下简称“本协议”）的接受，并同意接受本协议各项条款的约束，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。您认真阅读并充分理解后确认：您在点击同意《TCL用户协议》后，本协议即构成对双方具有约束力的法律文件并立即生效。</b>
                        </p>
                    </div>
                   
                    <div>
                        
                         <h3> 一、用户使用说明</h3>
                         <p>1、TCL根据中华人民共和国法律为您提供相关产品、程序及相关服务。</p>
                         <p>2、TCL为您提供购远程监控产品的平台服务，为改善用户体验或经营需要，服务平台的产品、项目、规则和内容可能会不时调整，如您继续使用本服务平台，视为您同意对上述内容的修改。 </p>
                         <p>3、由于服务平台的特殊性，您同意接受和谅解以下操作：</p>  
                         <ul>
                            <li><b>（1）TCL需要定期或不定期地对服务平台或相关设备进行检修和维护，如因此类情况造成服务在合理时间内的中断，TCL无需为此承担任何责任，TCL应尽可能事先通告。</b> </li>
                            <li><b>（2）TCL会有权自动升级应用在服务平台上的软件（包含产品的固件）。</b>这种软件升级一般是用于改善服务或提高产品的性能，安全性及稳定性，同时也包含修复错误，提高服务及产品的功能以及软件的升级和功能改善（也包含全新的版本）。本自动升级通过便携设备或网络连接，在用户退出账号的情况也可以继续提供。  </li>
                        </ul>
                        <p> 4、为了准确优质地向您提供服务，请确保： </p>
                        <ul>
                            <li>（1）注册资料的真实、准确、详尽；</li>
                            <li>（2）注册信息如有变更，请及时更新。</li>
                        </ul>
                         <p>
                             <b>5、因TCL服务的扩展或者深化，本协议及相关规则可能会不时更新，请予以关注，如您继续使用服务平台，意味着您已经同时详细阅读并接受了本协议条款及相关规则的变动，认可更新的协议及相关规则对您的约束力。如您不同意服务平台对本协议条款及相关规则内容所做的修改，请您立即停止使用服务平台。</b>
                         </p>
                         <p>
                            <b>6、服务平台内商品信息随时有可能发生变动，TCL对此不作特别通知。</b> 
                         </p>
                         <p>
                             7、本协议条款是处理双方权利义务的约定依据，违反国家强制性法律除外，否则始终有效。<b>在使用服务平台前，您应当确保您具备中华人民共和国法律规定的与您行为相适应的民事行为能力，并且将您对您在服务平台所有信息的真实性负责。</b>若您不具备前述与您行为相适应的民事行为能力，则您应当在您的监护人的参与下使用服务平台，您及您的监护人应依照法律规定承担因此而导致的一切后果。
                         </p>
                         <p></p>
                         <p></p>
                    </div>

                    <div>
                        <h3>二、用户信息的保护及授权</h3>
                        <p><b>1、在您注册、使用本服务平台、使用TCL产品时，为了优化服务质量，TCL可能会获取您的设备使用信息和个人信息（包括但不限于您的真实姓名、性别、生日、身高、体重、配送地址、手机号码、微信、QQ、肖像等），您同意授权TCL收集收取上述信息。</b></p>
                        <p><b>2、TCL将根据本协议规定对您的设备使用信息和个人信息进行严格保密。您同意，授权服务平台存储、使用、共享您提交至服务平台的个人信息和其它信息，同意您的设备使用信息和个人信息可以在TCL共享。</b></p>
                        <p>3、对于您的个人信息，您享有查询、更正、删除以及注销服务或帐号的权利。</p>
                        <p>4、根据您的注册权限可以进行相关信息的发布，您声明并保证，您对您所发布的信息拥有相应、合法的权利，且所发布的信息不是禁止性信。<b>以下信息属于禁止性信息，TCL可对该禁止性信息依法或依本协议进行删除或屏蔽。</b></p>
                        <ul>
                            <li>1）违反国家法律法规禁止性规定的； </li>
                            <li>2）政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的； </li>
                            <li>3）欺诈、虚假、不准确或存在误导性的；</li>
                            <li>4）侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；</li>
                            <li>5）侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；</li>
                            <li>6）存在可能破坏、篡改、删除、影响服务平台任何系统正常运行或未经授权秘密获取服务平台及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；</li> 
                            <li>7）其他违背社会公共利益或公共道德或依据服务平台相关协议、规则的规定不适合在服务平台上发布的。</li>
                        </ul>  
                        <p> 5、TCL尊重用户的隐私权，您的设备使用信息和个人信息在下述情况中部分或全部向TCL外的第三人披露：</p>    
                        <ul>
                            <li>1) 经您同意，向第三人披露。</li>
                            <li>2)根据法律的有关规定，或者行政或司法机构的要求，向第三人或者行政、司法机构披露。 </li>
                            <li>3) 您与任何第三人产生权利纠纷，为便于双方处理纠纷而作的相应披露。</li>
                            <li>4) 如果您出现违反网站政策的情况，需要向第三方披露。 </li>
                            <li>5) 为提供你所要求的产品或服务，而必须和第三方分享的您的个人信息。 </li>
                            <li>6) 其他TCL根据法律或者相关政策认为合适的披露。</li>
                        </ul>        
                    </div>

                    <div>
                        <h3>三、注册用户权利</h3>
                        <p>1、TCL遵守国家法律法规，保护每一位注册用户的合法权利，公平对待每一位注册用户，所有用户一律平等。 </p>   
                        <p>2、TCL尊重用户的肖像权及对发布内容的所有权，未经您的同意，TCL将不用作任何商业用途。</p>
                    </div>

                    <div>
                        <h3>四、注册用户义务</h3>
                        <p><b>1、您需从TCL授权的第三方获取本软件，如果您从未经TCL授权的第三方获取本软件或者与本软件名称相同的安装程序，TCL无法保证该软件的正常使用，并对因此给您造成的损失不予负责。</b></p>   
                        <p>2、用户名、昵称和头像的注册与使用应符合网络道德，遵守中华人民共和国的相关法律法规；用户名、 昵称和头像中不能含有威胁、淫秽、漫骂、非法、侵害他人权益或者可能让人产生上述联想的的文字或图片。 </p>
                        <p><b>3、注册成功后，您必须保护好自己的帐号和密码，因您本人泄露而造成的任何损失由您本人负责。同时，通过您的个人账户在TCL相关产品、程序及服务上发生的所有活动产生的责任，应由您承担。</b></p>
                        <p>4、您不得冒充他人注册TCL相关产品、程序和服务，也不得盗用他人帐号，如有该行为，造成的任何法律责任将由您自行承担。 </p>
                        <p>5、您不得利用TCL相关产品、程序及服务进行违法犯罪、危害国家安全、泄露国家秘密、侵犯他人合法权益的活动， 并不得利用TCL相关产品、程序及服务制作、复制和传播。 </p>
                        <p>6、未经TCL的授权或许可，任何情况下，您不得借用TCL相关产品、程序及服务的名义从事任何商业活动，也不得将TCL相关产品、程序及服务作为从事商业活动的场所、平台或其他任何形式的媒介；禁止将TCL相关产品、程序及服务用作从事各种非法活动的场所、平台或者其他任何形式的媒介。 </p>
                        <p>7、对侵害TCL和TCL相关产品、程序及服务的信息，请向服务平台客户服务举报。如有触犯法律的行为，将移送司法机关处理。</p>
                    </div>

                    <div>
                        <h3>五、知识产权</h3>
                        <p>1、TCL相关产品、程序及服务上的所有内容，如商标、文字、图片、标识、广告都是TCL或者其内容提供者的排他性财产，您不可以未经授权擅自使用，同时，这些内容不可以被用于任何可能引起消费者对TCL的服务引起混淆或者贬低的商品或者服务上。 </p>   
                        <p>2、未经TCL书面同意，您不可以用任何方式对本服务平台内容进行修改，也不可复制、下载、转载、引用、链接、抓取或以其他方式对本服务平台内容、数据、信息进行转售或商业利用。 </p>
                    </div>
                    
                    <div>
                        <h3>六、 用户的违约及处理</h3>
                        <p><b>1、发生如下情形之一的，视为您违约： 
                            <br/>1）使用服务平台时违反有关法律法规规定的；
                            <br/>2）违反本协议或服务平台相关政策、规定、通知、协议约定的。 </b>
                        </p>   
                        <p> 2、如您的行为使TCL遭受损失（包括直接经济损失、商誉损失、对外支付的赔偿金、补偿金、和解款、律师费、诉讼费等所有经济损失），您应赔偿TCL的上述全部损失。  </p>
                    </div>

                    <div>
                        <h3>七、协议的终止</h3>
                        <p>1、您有权通过以下任一方式终止本协议： 
                            <br/>1）在满足服务平台公示的账户注销条件时您通过服务平台注销您的账户的； 
                            <br/>2）变更事项生效前您停止使用并明示不愿接受变更事项的； 
                            <br/>3）您明示不愿继续使用平台服务，且符合终止条件的。
                        </p> 
                        <p>2、出现以下情况时，TCL有权终止与您签署的本协议： 
                              <br/>1）您违反本协议或服务平台相关政策、规定、通知、协议约定的 
                              <br/>2）您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为的； 
                              <br/>3）侵犯他人合法权益或其他严重违法违约行为的；  
                        </p> 
                    </div>

                    <div>
                        <h3>八、免责条款 </h3>
                        <p>1、虽然TCL已将所有信息和资料进行过认真编辑与审查，但是仍然可能存在错误或不准确的信息。TCL不保证以下各项：信息和资料中包含的功能将不受干扰或没有错误；信息和资料将符合您的特定要求；缺陷将被纠正；TCL的服务器没有病毒或其它有害成分；通过TCL相关产品、程序及服务所传送的讯息将能维持保密。<b>对于信息和资料的正确性、准确性、可靠性或其它方面而言， TCL概不对信息和资料的使用或使用后果做出任何保证或者担保。</b> </p>   
                        <p><b>2、对于因病毒、系统缺陷、人对计算机系统的作为或不作为、电话线、硬件、软件、程序出错或其它由于使用TCL产品、程序和服务而引起的计算机传输或网络连接错误、失败或延迟造成的损害，TCL也不承担责任，即便这些损害是由于您登录或使用TCL相关产品、 程序及服务的。TCL不保证产品、程序和服务的使用是持续的、不中断的或安全的。</b> </p>
                        <p><b>3、由于您的保管疏忽导致帐号、密码遭他人非法使用。TCL不承担任何法律责任。 </b></p>
                        <p><b>4、服务平台对因不可抗力或其他无法控制的原因（如服务平台系统异常或无法使用）导致远程监控无法完成或丢失有关的信息、记录等，TCL会合理地尽力协助处理善后事宜。</b> </p>
                    </div>

                    <div>
                        <h3>九、其他 </h3>
                        <p>1、本协议的订立、执行、解释及争议解决均适用中华人民共和国法律（不包括香港、澳门、台湾地区）。本协议条款具有统一性，但是部分条款无效不影响其它部分条款的效力。</p>   
                        <p>2、如果您是TCL相关产品、程序和服务的注册用户，本协议条款将对持续有效，有效期至您注销或者被关闭账户后，但知识产权相关条款在此后继续有效。</p>   
                        <p>3、如有任何争议，应先友好协商解决，协商不成，应提交广东TCL智能暖通设备有限公司所地有管辖权的人民法院诉讼处理。 </p>
                        <p>4、本协议内容中以加粗方式显著标识的条款，请您着重阅读。您点击“同意”按钮即视为您完全接受本协议在点击之前请您再次确认已知悉并完全理解本协议的全部内容。  </p>
                    </div>
              </div>
            </div>
              
        )
    }
}
export default Agreement;